import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { useTranslation } from "@/hooks/useTranslation";
import { CalendarIntegrationStopReason } from "@shaarp/common";
import { TriangleAlert } from "lucide-react";

type CalendarIntegrationStoppedAlertProps = {
  readonly stoppedReason: CalendarIntegrationStopReason | null;
};

/**
 * Says, on the page the stop email links to, that the calendar is no longer
 * syncing and why. Without it the user follows the email's call to action and
 * reads "Connected" with their calendar still selected.
 *
 * A revoked grant never reaches here: the API answers "not connected" for it, so
 * the page already offers to reconnect.
 */
export default function CalendarIntegrationStoppedAlert({
  stoppedReason,
}: CalendarIntegrationStoppedAlertProps) {
  const { t } = useTranslation();

  if (!stoppedReason) {
    return null;
  }

  return (
    <Alert variant="warning">
      <TriangleAlert />
      <AlertTitle>{t("team.integrations.calendar.stopped.title")}</AlertTitle>
      <AlertDescription>
        {t(`team.integrations.calendar.stopped.cause.${stoppedReason}`)}
      </AlertDescription>
    </Alert>
  );
}
